import { GzSingleSelectComplexBaseDataProvider } from '../GzSingleSelectComplexBaseDataProvider';
import { ConsoleRequest, DataProviderType } from '../../../../utils/request';
import { DEFAULT_DATA_LIMIT, GetItemsRequest, GetItemsResponse } from '../../types';

export class ADUsersForAccountsDataProvider extends GzSingleSelectComplexBaseDataProvider {
  async getItems({ searchValue, page, limit }: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    try {
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'LdapUsers',
        method: 'getItems',
        payload: {
          page: page,
          limit: limit,
          userName: searchValue
        },
      });

      return {
        items: response.data.map(({ _id, userName, email, fullName }) => ({
          value: _id,
          label: userName,
          email: email,
          fullName: fullName,
        })),
        totalItemsCount: response.count,
      };
    } catch (e) {
      throw new Error(e);
    }
  }

  async getInitialItems(request: GetItemsRequest): Promise<GetItemsResponse | undefined> {
    try {
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.CORE,
        endpoint: 'LdapUsers',
        method: 'getItems',
        payload: {
          page: 1,
          limit: DEFAULT_DATA_LIMIT,
        },
      });

      return {
        items: response.data.map(({ _id, userName, email, fullName }) => ({
          value: _id,
          label: userName,
          email: email,
          fullName: fullName,
        })),
        totalItemsCount: response.total,
      };
    } catch (e) {
      throw new Error(e);
    }
  }
}
